export const ip = "http://hr.pangodso.com/web_api/"; //正式环境地址
// export const ip = "http://192.168.40.78:8115/"; //测试地址
export const codeURL = ip + "index/loginAdmin/getVerify"; //登录图形验证码
export const URL = "http://hr.pangodso.com/web_file/"; //图片地址前缀
export const uploadURL = ip + "web/file/upload"; //上传地址
